import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

type Props = {
  path: string;
  disabled?: boolean;
};

export function ViewButton({ path, disabled = false }: Props) {
  const { pathname } = useLocation();

  const fullPath = `${pathname}/${path}`;

  return (
    <div className="flex h-full items-center">
      <Link
        to={disabled ? '#' : fullPath}
        onClick={e => {
          if (disabled) e.preventDefault();
        }}
        className={cn(
          'mx-2 flex h-[28px] flex-1 items-center justify-center rounded-sm border border-[#3B6FEC] px-2 text-sm text-[#3B6FEC] hover:bg-[#3B6FEC] hover:text-white',
          disabled && 'pointer-events-none opacity-50'
        )}>
        View
      </Link>
    </div>
  );
}
